var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row",staticStyle:{"overflow":"hidden"},style:(`width: ${_vm.width}px; height: ${_vm.height}px;`)},[_c('c-img',{staticClass:"c-trn c-img",style:(`width: 100%; ${_vm.calcRotate(_vm.f)}`),attrs:{"src":`/thumb/${_vm.tSize(_vm.f, _vm.width)}/${_vm.f.id}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }